import { render, staticRenderFns } from "./String.vue?vue&type=template&id=52ea2804&"
import script from "./String.vue?vue&type=script&lang=js&"
export * from "./String.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports